import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertService } from "app/core/alert/alert.service";
import { ETipoCampoPesquisaAvancada } from "app/shared/enum";
import { IEnumArray, IFiltroAvancado } from "app/shared/shared.model";
import moment from "moment";

@Component({
    selector: "app-filtro-avancado",
    templateUrl: "./filtro-avancado.component.html",
    standalone: false
})
export class FiltroAvancadoComponent implements OnInit {
  @Input() filtros: IFiltroAvancado[] = [];
  @Input() tipoSelecionado = 1;
  @Input() filtrosSelecionados: IFiltroAvancado[] = [];

  @Output()
  filtrar = new EventEmitter<IFiltroAvancado[]>();

  termoPesquisa: any;
  data_inicio: Date;
  data_fim: Date;

  dadosEnum: IEnumArray[] = [];

  mostrarInputText = false;
  mostrarInputNumer = false;
  mostrarInputRange = false;
  mostrarInputData = false;
  mostrarEnum = false;

  constructor(private _alert: AlertService) {}

  ngOnInit(): void {
    this.mostrarInput();

    if (this.filtrosSelecionados.length && this.filtrosSelecionados[0].codigo === 1) {
      this.filtros = this.filtros.filter(
        (item) => item.codigo !== this.tipoSelecionado
      );
      if (this.filtros.length > 0) {
        this.tipoSelecionado = this.filtros[0].codigo;
      }
    }
  }

  adicionarFiltro(): void {
    const filtroSelecionado = this.filtros.find(
      (item) => item.codigo === this.tipoSelecionado
    );

    let valor;
    let valorMostrar;

    switch (filtroSelecionado.tipo) {
      case ETipoCampoPesquisaAvancada.DATA_RANGE:
        const inicio = moment(this.data_inicio).format("YYYY-MM-DD");
        const fim = moment(this.data_fim).format("YYYY-MM-DD");
        if (inicio === "Invalid date" || fim === "Invalid date") {
          this._alert.warning("Data inicio ou data fim inválida!");
          return;
        }
        valor = `${inicio},${fim}`;
        valorMostrar = `${moment(this.data_inicio).format(
          "DD/MM/YYYY"
        )} - ${moment(this.data_fim).format("DD/MM/YYYY")}`;
        break;
      case ETipoCampoPesquisaAvancada.DATA:
        const data = moment(this.termoPesquisa).format("YYYY-MM-DD");
        if (data === "Invalid date") {
          this._alert.warning("Data informada inválida!");
          return;
        }

        valor = moment(this.termoPesquisa).format("YYYY-MM-DD");
        valorMostrar = moment(this.termoPesquisa).format("DD/MM/YYYY");
        break;
      case ETipoCampoPesquisaAvancada.ENUM:
        valor = this.termoPesquisa["valor"];
        valorMostrar = this.termoPesquisa["texto"];
        break;
      default:
        valor = this.termoPesquisa;
        valorMostrar = this.termoPesquisa;
    }

    const filtro = { ...filtroSelecionado, valor, valorMostrar };

    this.filtrosSelecionados.push(filtro);

    this.filtros = this.filtros.filter(
      (item) => item.codigo !== this.tipoSelecionado
    );

    this.termoPesquisa = null;
    if (this.filtros.length > 0) {
      this.tipoSelecionado = this.filtros[0].codigo;
    }

    this.filtrar.emit(this.filtrosSelecionados);
    this.mostrarInput();
  }

  removerFiltro(codigo: number): void {
    const filtroRemovido = this.filtrosSelecionados.find(
      (filtro) => filtro.codigo === codigo
    );

    if (filtroRemovido) {
      this.filtros.unshift({ ...filtroRemovido, valor: null });
      this.filtrosSelecionados = this.filtrosSelecionados.filter(
        (item) => item.codigo !== codigo
      );
      this.termoPesquisa = null;
      this.tipoSelecionado = this.filtros[0].codigo;

      this.filtrar.emit(this.filtrosSelecionados);
      this.mostrarInput();
    }
  }

  mostrarInput(): void {
    const itemSelecionado = this.filtros.find(
      (item) => item.codigo === this.tipoSelecionado
    );

    if (itemSelecionado) {
      this._ocultaTodosInputs();

      switch (itemSelecionado.tipo) {
        case ETipoCampoPesquisaAvancada.TEXTO:
          this.mostrarInputText = true;
          break;

        case ETipoCampoPesquisaAvancada.NUMERICO:
          this.mostrarInputNumer = true;
          break;

        case ETipoCampoPesquisaAvancada.DATA_RANGE:
          this.mostrarInputRange = true;
          break;

        case ETipoCampoPesquisaAvancada.DATA:
          this.mostrarInputData = true;
          break;

        case ETipoCampoPesquisaAvancada.ENUM:
          this.mostrarEnum = true;
          this.dadosEnum = itemSelecionado.arrayEnum;
          break;
      }
    }
  }

  private _ocultaTodosInputs(): void {
    this.mostrarInputText = false;
    this.mostrarInputNumer = false;
    this.mostrarInputRange = false;
    this.mostrarInputData = false;
    this.mostrarEnum = false;
  }
}
